<template>
  <section class="strategy">
      <div class="strategy__content container">
        <div class="strategy__columns">
          <div class="strategy__text --fade-in-right" data-vertical-ivp-class="--animate">
            <h1>A Solid Strategy</h1>
            <p>
              - We aim to build, develop, and/or acquire technologies that  will allow us to launch
              e-commerce portals that will  streamline the integration of our ESC warranty services with
              a cloud-based  platform. In this way, we believe we will be able to expand our reach while
              increasing the value of our ESC warranty services.
            </p>
            <p>
              - The development of  ONBLi will allow us to expand into cloud-based product sales and related services.
              By selling additional products through e-commerce, we can enhance customer reach,
              develop and link complementary services, expand our technological knowledge, and quickly
              build critical mass in support of creating a sustainable corporate enterprise that can defend,
              endure, and thrive in the current evolving marketplace
            </p>
            <p>
              - MHHC has recently transitioned to the OTCQB exchange. This move will increase transparency,
              heighten reporting standards, require management certification, and add additional compliance
              requirements, which can result in greater liquidity and awareness. We are excited to bring MHHC
              into higher levels of transparency, and increase investor confidence.
            </p>
            <div class="strategy__button">
              <a  class="button-outlined --text-dark"
                  href="https://mhhc.app.dealmaker.tech/invitations/c9a88252-39be-4be8-a114-1718712d60b7/view"
                  target="_blank">
                <div class="text">INVEST NOW</div>
                <div class="line -right"></div>
                <div class="line -top"></div>
                <div class="line -left"></div>
                <div class="line -bottom"></div>
              </a>
            </div>
          </div>
          <div class="strategy__image --fade-in-left" data-vertical-ivp-class="--animate">
             <img src="../assets/strategy/solidstrategy.png">
          </div>
        </div>
      </div>
  </section>
</template>

<script>
export default {
  name: 'Strategy',
  data () {
    return {
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../styles/components/strategy.scss";
</style>
